<script setup>
import PartnerTable from '@frontJs/components/tables/projectManagement/apikom/PartnerTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Partenaires - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Partenaires </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(PartnerTable),
            },
            archived: {
                title: 'Archivé',
                content: h(PartnerTable, { archived: true }),
            },
        }"
    />
</template>
